const ReCaptcha = {
  mounted() {
    const button = this.el;
    const form = button.closest('form');

    if (!form) {
      console.log("ReCaptcha initialization failed: form not found");
      return;
    }

    const initializeRecaptcha = () => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();

        button.disabled = true;
        const originalText = button.innerText;
        button.innerText = "Loading...";

        try {
          console.log("Executing reCAPTCHA...");
          const token = await window.executeRecaptcha();
          console.log("Got reCAPTCHA token", token.substring(0, 10) + "...");

          const recaptchaInput = form.querySelector('input[name="g-recaptcha-response"]');
          if (!recaptchaInput) {
            throw new Error("Recaptcha input field not found");
          }

          recaptchaInput.value = token;
          form.submit();
        } catch (error) {
          console.error("ReCaptcha error:", error);
          button.disabled = false;
          button.innerText = originalText;
        }
      });
    };

    // Wait for reCAPTCHA to load if necessary
    if (window.executeRecaptcha) {
      initializeRecaptcha();
    } else {
      if (window.onRecaptchaLoaded) {
        console.log("Waiting for reCAPTCHA to load...");
        window.onRecaptchaLoaded(initializeRecaptcha);
      }
    }
  }
};

export default ReCaptcha;
